import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import { Grid, makeStyles } from '@material-ui/core'
import SydModal from '../../commonDesign/SydModal'
import SydButton from '../../commonDesign/Button'
import { useAppContext } from '../../../redux/slices/appContext'
import PersonalSpace from '../../molecules/PersonalSpace'
import SydModalActions from '../../commonDesign/SydModal/SydModalActions'
import DateRangePicker from '../../molecules/DateRangePicker'

dayjs.extend(isSameOrBefore)

const useStyles = makeStyles((theme) => ({
  dateRangeInput: {
    background: '#FFFFFF',
    border: '1px solid var(--color-neutral-700)',
    borderRadius: 'var(--border-radius-sm)',
    padding: `${theme.layout.padding.p10} ${theme.layout.padding.p0} ${theme.layout.padding.p10} ${theme.layout.padding.p10}`,
    '& input': {
      padding: '0'
    }
  }
}))

function CustomRangeDialog ({ open, onClose, onSave }) {
  const classes = useStyles()
  const { availableDates } = useAppContext()
  const [value, setValue] = useState({
    startDate: null,
    endDate: null
  })
  const handleChange = useCallback((startDate, endDate) => {
    setValue({ startDate, endDate })
  }, [setValue])

  const handleSave = useCallback(() => {
    onSave({ ...value })
  }, [onSave, value])

  return (
    <SydModal
      disablePortal={false}
      title='Choose Custom Date Range'
      open={open}
      onClose={onClose}
      size='small'
    >
      <PersonalSpace size={40} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DateRangePicker
            className={classes.dateRangeInput}
            variant='space-evenly'
            onChange={handleChange}
            defaultStartDate={availableDates?.mainDate}
            defaultEndDate={availableDates?.mainDate}
            minDate={availableDates.min}
            maxDate={availableDates.max}
            format='MM/DD/YYYY'
            shouldDisableWeekends
            datePickerWidth='12rem'
            startDateLabel={null}
            endDateLabel={null}
            InputProps={{
              disableUnderline: true,
              error: false
            }}
          />
        </Grid>
      </Grid>
      <PersonalSpace size={40} />
      <SydModalActions>
        <SydButton
          variant='ghost'
          onClick={onClose}
        >
          Cancel
        </SydButton>
        <SydButton
          variant='primary'
          onClick={handleSave}
        >
          Select
        </SydButton>
      </SydModalActions>
    </SydModal>
  )
}

CustomRangeDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func
}

export default CustomRangeDialog
